export default "__VITE_ASSET__D4J8jhc3__"